module.exports = "https://coursera_assets.s3.amazonaws.com/images/c33b7fe287b0e5a781ddf13703195374.png";